import { Card, CardContent, CardMedia, Grid, Typography } from '@mui/material';
import useStyles from '../indexcss';
import requestData from './request.json';

const RequestService = () => {
  const classes = useStyles();
  const isDataEqualOrMoreThanEleven = requestData?.length >= 13;
  return (
    <div className={isDataEqualOrMoreThanEleven ? classes.dynamicheight : classes.RequestMainCard}>
      {' '}
      <div className={classes.borderText}>Request for a Service</div>
      <Grid container spacing={2} className={classes.marginToppx}>
        {requestData.map((service) => (
          <Grid item key={service.id} xs={12} md={3}>
            <Card className={classes.rsCard}>
              <CardMedia style={{ width: '12%', padding: '0px 14px' }} component="img" image={service.image} alt={service.title} />
              <CardContent style={{ paddingBottom: '0px', paddingTop: '10px' }}>
                <Typography className={classes.requestStypoh}>{service.title}</Typography>
                <Typography className={classes.requestStypod} color="textSecondary">
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default RequestService;
